
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/forex/outward-remittances",
      function () {
        return require("private-next-pages/help/forex/outward-remittances.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/forex/outward-remittances"])
      });
    }
  